import { useContext } from 'react';
import BackofficeContext from './BackofficeContextStore';
import type { BackofficeContextType } from './BackofficeContextStore';

export function useBackoffice(): BackofficeContextType {
  const ctx = useContext(BackofficeContext);
  if (!ctx) {
    throw new Error('useBackoffice must be used within BackofficeProvider');
  }
  return ctx;
}
